'use client';

import { createContext } from 'react';

import type { DatePickerFloatingContextInterface } from '../types/use-date-picker.types';

export const DatePickerFloatingContext = createContext({} as DatePickerFloatingContextInterface);

DatePickerFloatingContext.displayName = 'DatePicker.Floating.Context';
